/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EuPagoInit } from './EuPagoInit';
import {
    EuPagoInitFromJSON,
    EuPagoInitFromJSONTyped,
    EuPagoInitToJSON,
} from './EuPagoInit';

/**
 * 
 * @export
 * @interface MoneyInPayshopInitOutput
 */
export interface MoneyInPayshopInitOutput {
    /**
     * 
     * @type {EuPagoInit}
     * @memberof MoneyInPayshopInitOutput
     */
    euPagoInit?: EuPagoInit;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInPayshopInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInPayshopInitOutput interface.
 */
export function instanceOfMoneyInPayshopInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInPayshopInitOutputFromJSON(json: any): MoneyInPayshopInitOutput {
    return MoneyInPayshopInitOutputFromJSONTyped(json, false);
}

export function MoneyInPayshopInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInPayshopInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'euPagoInit': !exists(json, 'euPagoInit') ? undefined : EuPagoInitFromJSON(json['euPagoInit']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInPayshopInitOutputToJSON(value?: MoneyInPayshopInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'euPagoInit': EuPagoInitToJSON(value.euPagoInit),
        'error': value.error,
    };
}

